var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlexible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-circle-down",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,0h-6c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5h6c.231,0,.447,.057,.643,.15L12,11.293,1.857,1.15c.196-.094,.412-.15,.643-.15h6c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5H2.5C1.122,0,0,1.121,0,2.5v6c0,.276,.224,.5,.5,.5s.5-.224,.5-.5V2.5c0-.231,.057-.447,.15-.643L11.293,12,1.15,22.143c-.094-.196-.15-.412-.15-.643v-6c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v6c0,1.379,1.122,2.5,2.5,2.5h6c.276,0,.5-.224,.5-.5s-.224-.5-.5-.5H2.5c-.231,0-.447-.057-.643-.15L12,12.707l10.143,10.143c-.196,.094-.412,.15-.643,.15h-6c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5h6c1.378,0,2.5-1.121,2.5-2.5v-6c0-.276-.224-.5-.5-.5s-.5,.224-.5,.5v6c0,.231-.057,.447-.15,.643L12.707,12,22.85,1.857c.094,.196,.15,.412,.15,.643v6c0,.276,.224,.5,.5,.5s.5-.224,.5-.5V2.5c0-1.379-1.122-2.5-2.5-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.6daaa8a66968cb27c09386fcf2a50448.svg";
export { ForwardRef as ReactComponent };